import api from './api';

/**
 * Service do Dashboard Administrativo (visão consolidada cross-extensão).
 * Cada método chama um endpoint granular para permitir carregamento progressivo.
 * Aceita { signal } para cancelamento via AbortController.
 */
export const dashboardAdminService = {
  async alertas({ signal } = {}) {
    const response = await api.get('/dashboard-admin/alertas', { signal });
    return response.data;
  },

  async kpis({ periodo, dataInicio, dataFim, extensoes, compararPeriodoAnterior, tipoComparacao, signal } = {}) {
    const params = {};
    if (periodo) params.periodo = periodo;
    if (dataInicio) params.dataInicio = dataInicio;
    if (dataFim) params.dataFim = dataFim;
    if (extensoes && extensoes.length) params.extensoes = extensoes.join(',');
    if (compararPeriodoAnterior) params.compararPeriodoAnterior = 'true';
    if (tipoComparacao) params.tipoComparacao = tipoComparacao;
    const response = await api.get('/dashboard-admin/kpis', { params, signal });
    return response.data;
  },

  async extensoesRanking({ periodo, dataInicio, dataFim, extensoes, ordenarPor, ordem, page, limit, sparkline, signal } = {}) {
    const params = {};
    if (periodo) params.periodo = periodo;
    if (dataInicio) params.dataInicio = dataInicio;
    if (dataFim) params.dataFim = dataFim;
    if (extensoes && extensoes.length) params.extensoes = extensoes.join(',');
    if (ordenarPor) params.ordenarPor = ordenarPor;
    if (ordem) params.ordem = ordem;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (sparkline) params.sparkline = 'true';
    const response = await api.get('/dashboard-admin/extensoes-ranking', { params, signal });
    return response.data;
  },

  async recentes({ signal } = {}) {
    const response = await api.get('/dashboard-admin/recentes', { signal });
    return response.data;
  },

  async academico({ extensoes, signal } = {}) {
    const params = {};
    if (extensoes && extensoes.length) params.extensoes = extensoes.join(',');
    const response = await api.get('/dashboard-admin/academico', { params, signal });
    return response.data;
  },

  async financeiro({ periodo, dataInicio, dataFim, extensoes, signal } = {}) {
    const params = {};
    if (periodo) params.periodo = periodo;
    if (dataInicio) params.dataInicio = dataInicio;
    if (dataFim) params.dataFim = dataFim;
    if (extensoes && extensoes.length) params.extensoes = extensoes.join(',');
    const response = await api.get('/dashboard-admin/financeiro', { params, signal });
    return response.data;
  },

  async extensaoDetalhes(id, { periodo, signal } = {}) {
    const params = {};
    if (periodo) params.periodo = periodo;
    const response = await api.get(`/dashboard-admin/extensoes/${id}/detalhes`, { params, signal });
    return response.data;
  },
};

export default dashboardAdminService;
